import { post } from '../http/axios';
import { utils } from '@ohif/core';
import { Base64 } from 'js-base64/base64';

const OSSAccessKeyId = 'LTAI4G3VYppaS5Xs2J1DBRoG';
const AccessKeySecret = '5hLFiZ8xJPDSJ31Uul5PDzXKUcO7S3';
const ossBucketInfo = {
  endPoint: 'oss-cn-hangzhou.aliyuncs.com',
  bucketName: 'yinghe-ai',
  bucketDomain: 'yinghe-ai.oss-cn-hangzhou.aliyuncs.com',
  userBucketDomain: 'yinghe-ai.oss-cn-hangzhou.aliyuncs.com/',
};
const mockOSSData = {
  dir: 'picture/backendAdmin/',
  expire: '1577811661',
  host: '//www.mocky.io/v2/5cc8019d300000980a055e76',
  accessId: 'LTAI4G3VYppaS5Xs2J1DBRoG',
  policy: 'eGl4aWhhaGFrdWt1ZGFkYQ==',
  signature: 'ZGFob25nc2hhbw==',
};
const uploadFile = async (file, uploadSuccessCbs, onUploadProgress) => {
  // this.hasFileUploading$.next(true);
  let filePath = await asyncUploadFiles(file, onUploadProgress);
  uploadSuccessCbs(filePath);
};

const asyncUploadFiles = async (file, onUploadProgress) => {
  let originalFileName = file.name;
  let aliyunFileKey =
    mockOSSData.dir +
    new Date().getTime() +
    utils.guid() +
    originalFileName.substring(originalFileName.lastIndexOf('.'));
  const policyBase64 = getPolicyBase64();
  const signature = getAliyunOSSSignature(policyBase64); //获取签名

  const formData = new FormData();
  formData.append('key', aliyunFileKey);
  formData.append('OSSAccessKeyId', OSSAccessKeyId);
  formData.append('policy', policyBase64);
  formData.append('signature', signature);
  formData.append('success_action_status', '200');
  formData.append('file', file);

  let config = {
    headers: { 'Content-Type': 'multipart/form-data', isUpload: true },
    withCredentials: false,
    onUploadProgress,
  };
  let response = await post(
    `https://${ossBucketInfo.userBucketDomain}`,
    formData,
    config
  ).catch(err => {
    console.log(err);
    return {
      status: 'error',
      // error: error.message,
      message: '上传失败',
      url: '',
      name: originalFileName,
    };
  });
  if (response.status === 200) {
    // this.getJson(callbackBody);
    let fileInfo = {
      status: 'done',
      message: '上传成功',
      url: response.config.url + aliyunFileKey,
      name: originalFileName,
    };
    return fileInfo;
  } else {
    console.log('上传失败');
  }
};

const getPolicyBase64 = () => {
  const date = new Date();
  date.setHours(date.getHours() + 24);

  const policyText = {
    expiration: date.toISOString(), //设置该Policy的失效时间，超过这个失效时间之后，就没有办法通过这个policy上传文件了
    conditions: [
      ['content-length-range', 0, 5000 * 1024 * 1024], // 设置上传文件的大小限制,500mb
    ],
  };

  return Base64.encode(JSON.stringify(policyText));
};

const getAliyunOSSSignature = policyBase64 => {
  const bytes = HMAC(policyBase64, AccessKeySecret, {
    asBytes: true,
  });
  return bytesToBase64(bytes);
};

const HMAC = (message, key, options) => {
  // Allow arbitrary length keys
  key = key.length > 16 * 4 ? SHA1(key, { asBytes: true }) : stringToBytes(key);

  // XOR keys with pad constants
  var okey = key,
    ikey = key.slice(0);
  for (var i = 0; i < 16 * 4; i++) {
    okey[i] ^= 0x5c;
    ikey[i] ^= 0x36;
  }

  var hmacbytes = SHA1(
    bytesToString(okey) +
    SHA1(bytesToString(ikey) + message, { asString: true }),
    { asBytes: true }
  );
  return options && options.asBytes
    ? hmacbytes
    : options && options.asString
      ? bytesToString(hmacbytes)
      : bytesToHex(hmacbytes);
};

const SHA1 = (message, options) => {
  var digestbytes = wordsToBytes(_sha1(message));
  return options && options.asBytes
    ? digestbytes
    : options && options.asString
      ? bytesToString(digestbytes)
      : bytesToHex(digestbytes);
};

const _sha1 = message => {
  var m = stringToWords(message),
    l = message.length * 8,
    w = [],
    H0 = 1732584193,
    H1 = -271733879,
    H2 = -1732584194,
    H3 = 271733878,
    H4 = -1009589776;

  // Padding
  m[l >> 5] |= 0x80 << (24 - (l % 32));
  m[(((l + 64) >>> 9) << 4) + 15] = l;

  for (var i = 0; i < m.length; i += 16) {
    var a = H0,
      b = H1,
      c = H2,
      d = H3,
      e = H4;

    for (var j = 0; j < 80; j++) {
      if (j < 16) w[j] = m[i + j];
      else {
        var n = w[j - 3] ^ w[j - 8] ^ w[j - 14] ^ w[j - 16];
        w[j] = (n << 1) | (n >>> 31);
      }

      var t =
        ((H0 << 5) | (H0 >>> 27)) +
        H4 +
        (w[j] >>> 0) +
        (j < 20
          ? ((H1 & H2) | (~H1 & H3)) + 1518500249
          : j < 40
            ? (H1 ^ H2 ^ H3) + 1859775393
            : j < 60
              ? ((H1 & H2) | (H1 & H3) | (H2 & H3)) - 1894007588
              : (H1 ^ H2 ^ H3) - 899497514);

      H4 = H3;
      H3 = H2;
      H2 = (H1 << 30) | (H1 >>> 2);
      H1 = H0;
      H0 = t;
    }

    H0 += a;
    H1 += b;
    H2 += c;
    H3 += d;
    H4 += e;
  }

  return [H0, H1, H2, H3, H4];
};

const bytesToBase64 = bytes => {
  var base64map =
    'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
  if (typeof btoa == 'function') return btoa(bytesToString(bytes));

  var base64 = [],
    overflow;

  for (var i = 0; i < bytes.length; i++) {
    switch (i % 3) {
      case 0:
        base64.push(base64map.charAt(bytes[i] >>> 2));
        overflow = (bytes[i] & 0x3) << 4;
        break;
      case 1:
        base64.push(base64map.charAt(overflow | (bytes[i] >>> 4)));
        overflow = (bytes[i] & 0xf) << 2;
        break;
      case 2:
        base64.push(base64map.charAt(overflow | (bytes[i] >>> 6)));
        base64.push(base64map.charAt(bytes[i] & 0x3f));
        overflow = -1;
    }
  }

  // Encode overflow bits, if there are any
  if (overflow != undefined && overflow != -1)
    base64.push(base64map.charAt(overflow));

  // Add padding
  while (base64.length % 4 != 0) base64.push('=');

  return base64.join('');
};

const stringToBytes = str => {
  var bytes = [];
  for (var i = 0; i < str.length; i++) bytes.push(str.charCodeAt(i));
  return bytes;
};

const bytesToString = bytes => {
  var str = [];
  for (var i = 0; i < bytes.length; i++)
    str.push(String.fromCharCode(bytes[i]));
  return str.join('');
};

const bytesToHex = bytes => {
  var hex = [];
  for (var i = 0; i < bytes.length; i++) {
    hex.push((bytes[i] >>> 4).toString(16));
    hex.push((bytes[i] & 0xf).toString(16));
  }
  return hex.join('');
};

const stringToWords = str => {
  var words = [];
  for (var c = 0, b = 0; c < str.length; c++, b += 8)
    words[b >>> 5] |= str.charCodeAt(c) << (24 - (b % 32));
  return words;
};

const wordsToBytes = words => {
  var bytes = [];
  for (var b = 0; b < words.length * 32; b += 8)
    bytes.push((words[b >>> 5] >>> (24 - (b % 32))) & 0xff);
  return bytes;
};

export { uploadFile };
